const CardLoader = () => {
    return (
        <div className="card-loader">
            <div className="content-placeholder">
                <div className="line line-long"></div>
            </div>
        </div>
    );
};

export default CardLoader;